import { closeBar } from './announcement-bar';

const $win = $(window);
const $doc = $(document);

$doc
  .on('click', '.js-trigger-search', function(e) {
    e.preventDefault();

    console.log(e);

    if (!$(e.target).hasClass('search__field')) {
      $('.header').toggleClass('js-search-active');
      $('.wrapper').toggleClass('js-overlay js-trigger-search');
    }

    if ($('.header').hasClass('js-search-active')) {
      $('.form-search--header:visible input[type="search"]').focus();
    }
  })
  .on('click', '.js-close-bar', function(e) {
    e.preventDefault();
    
    closeBar();
  })
  /* This prevents PF & S on the search template to work correctly
  
  .on('click', 'a[href*="/search"]', function(e){
    e.preventDefault();
    
    const $this = $(this);
    $this.attr('href', $this.attr('href') + '&type=product');
    window.location.href = $this.attr('href');
  })*/
